import React from 'react';

import { Attachment, AttachmentFilesTypes } from 'Shared/types/Attachment.type';

// Utils
import * as AttachmentUtils from 'Shared/utils/Attachment.utils';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody } from 'Wpds/components/page-layout';
import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import WpIcon from 'Wpds/components/icon/WpIcon';
import VideoPlayer from '../AttachmentTypes/VideoPlayer';
import AudioPlayer from '../AttachmentTypes/AudioPlayer';
import ImageViewer from '../AttachmentTypes/ImageViewer';
import AttachmentTypeLogo from '../AttachmentTypeLogo';

// Hooks
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Styles
import './AttachmentViewer.scss';

type Props = {
  attachment: Attachment;
  toggleModal: Function;
  handleDownload: Function;
};

const AttachmentViewer = ({ attachment, toggleModal, handleDownload }: Props) => {
  const fileName = attachment.fileName;
  const fileType = AttachmentUtils.getFileType({ attachment });
  const { tr } = useTranslation();

  const handleCloseClick = () => {
    toggleModal();
  };

  const baseClassName = 'AttachmentViewer';

  return (
    <WpPageLayout width="full" className={baseClassName}>
      <WpPageHeader sticky>
        <div className={`${baseClassName}__header`}>
          <div className={`${baseClassName}__header__details`}>
            <AttachmentTypeLogo attachment={attachment} className={`${baseClassName}__header__details__icon`} />
            <p className={`${baseClassName}__header__details__name`}>{fileName}</p>
          </div>
          <div className={`${baseClassName}__header__actions`}>
            <WpButtonGroup spacing="md">
              <WpButton variant="tertiary" onClick={() => handleDownload()}>
                <WpIcon name="download" />
                {tr('perform.attachments.actions.download')}
              </WpButton>
              <WpButton variant="tertiary" onClick={handleCloseClick}>
                <WpIcon name="times" />
              </WpButton>
            </WpButtonGroup>
          </div>
        </div>
      </WpPageHeader>
      <WpPageBody>
        <div className={`${baseClassName}__viewer`}>
          {fileType === AttachmentFilesTypes.IMAGE && <ImageViewer attachment={attachment} />}
          {fileType === AttachmentFilesTypes.VIDEO && <VideoPlayer attachment={attachment} />}
          {fileType === AttachmentFilesTypes.AUDIO && <AudioPlayer attachment={attachment} />}
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default AttachmentViewer;
